import axios from "axios";
import { localStorageKey } from "../../BookingEngineIntegration/AuthContext";
import {
  guestbookSites,
  environment,
} from "../../../settings/IntegrationConstants";

declare module "axios" {
  export interface AxiosRequestConfig {
    crossDomain?: boolean;
  }
}

const AxiosTokenHelper = () => {
  let headers = {
    "Token-Authorization": "",
  };
  let jwt = localStorage.getItem(localStorageKey);
  headers["Token-Authorization"] = `Bearer ${jwt}`;

  const axiosInstance = axios.create({
    headers,
  });

  axiosInstance.interceptors.request.use((req) => {
    req.url = `${guestbookSites[environment as string].rewardsdash.url}${
      req.url
    }`;
    return req;
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log("Token Error: ", error);
      if (error.response.status === 401) {
        console.log("The token has expired.");
        localStorage.removeItem(localStorageKey);
      }
      return error.response;
    }
  );

  return axiosInstance;
};

export default AxiosTokenHelper;
